// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2zqeg","label":"LabeledBox_label__2kZXM"};